import * as React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { Link } from 'react-router-dom'
import { useDate } from 'utils/useDate'
import { useTranslation } from 'react-i18next'

type ProposalStateRegisterProps = {
  bidderContactEmail: string
  proposalTS: Date
}

const ProposalStateRegister: React.FC<ProposalStateRegisterProps> = ({ bidderContactEmail, proposalTS }) => {
  const { formatDate } = useDate()
  const { t } = useTranslation()

  return (
    <Box sx={{ width: '100%', borderRadius: 1, backgroundColor: '#EFEFEF', p: 2, maxWidth: 443 }}>
      <header>
        <Typography paragraph>{t('request-for-proposal-has-already-been-answered')}</Typography>
      </header>
      <Typography variant="body2" paragraph color="textSecondary">
        {`${t('proposal-state-1')} ${formatDate(proposalTS, 'd.M.yyyy')}, ${t(
          'proposal-state-2'
        )} ${bidderContactEmail}. ${t('proposal-state-3')}`}
      </Typography>
      <Typography variant="body2" paragraph color="textSecondary">
        {t('register-state-text')}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
        <Button variant="contained" component={Link} to={`/vendors/login`}>
          {t('register')}
        </Button>
      </Box>
    </Box>
  )
}

export default ProposalStateRegister
